import { useSyncExternalStore } from 'react'
import type { RegisterCfdType } from '@vend/types/register'

import { useRegisterManager } from '../../../ng-compat/hooks'
import { CFD_TYPE } from '../constants'

/**
 * Returns the CFD type for the active register, or undefined if the active
 * register has not yet been hydrated.
 *
 * Subscribes to the register manager's `activeRegisterChange` event so the
 * component re-renders once the register (and therefore its `cfd_type`) is
 * loaded from indexedDB after mount.
 */
export const useRegisterCfdType = (): RegisterCfdType | undefined => {
  const registerManager = useRegisterManager()

  return useSyncExternalStore(
    onStoreChange => {
      registerManager?.on('activeRegisterChange', onStoreChange)
      return () => registerManager?.off('activeRegisterChange', onStoreChange)
    },
    () => registerManager?.getActiveRegister?.()?.cfd_type
  )
}

/**
 * Convenience wrapper for the common check.
 */
export const useIsByodCfd = (): boolean =>
  useRegisterCfdType() === CFD_TYPE.BYOD
